'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const faqs = [
  {
    id: 'faq-1',
    q: 'Est-ce que les abonnés/likes sont réels ?',
    a: 'Oui, tous nos abonnés, likes et commentaires proviennent de profils réels et actifs. Nous n\'utilisons jamais de bots ou de faux comptes. La livraison est progressive pour imiter une croissance naturelle.',
  },
  {
    id: 'faq-2',
    q: 'Comment se passe le paiement via Orange Money ?',
    a: 'Après avoir sélectionné votre pack et rempli le formulaire, vous choisissez Orange Money comme méthode de paiement. Vous recevrez une demande de confirmation sur votre téléphone. Validez et votre commande est automatiquement traitée.',
  },
  {
    id: 'faq-3',
    q: 'Mon compte Facebook est-il en sécurité ?',
    a: 'Absolument. Nous n\'avons jamais besoin de votre mot de passe. Nous utilisons uniquement le lien public de votre page ou publication. Votre compte ne court aucun risque.',
  },
  {
    id: 'faq-4',
    q: 'Combien de temps prend la livraison ?',
    a: 'Les délais varient selon le service et la quantité : les likes sont livrés en 1 à 6 heures, les abonnés en 6 à 72 heures, et les commentaires en 6 à 48 heures. Les grandes quantités peuvent prendre jusqu\'à 7 jours.',
  },
  {
    id: 'faq-5',
    q: 'Que se passe-t-il si je ne reçois pas ma commande ?',
    a: 'Nous offrons une garantie 30 jours. Si votre commande n\'est pas livrée dans le délai annoncé, nous vous remboursons intégralement ou relivrons gratuitement. Contactez notre support WhatsApp.',
  },
  {
    id: 'faq-6',
    q: 'Puis-je commander pour une page d\'entreprise ?',
    a: 'Oui, nos services fonctionnent pour les pages personnelles, les pages d\'entreprises, les groupes Facebook et les publications individuelles. Il suffit de fournir le lien public.',
  },
];

export default function ServicesFAQ() {
  const [openId, setOpenId] = useState<string | null>('faq-1');

  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <div className="section-label mb-5 mx-auto" style={{ display: 'inline-flex' }}>
            <Icon name="QuestionMarkCircleIcon" size={13} className="text-[#1877F2]" />
            Questions fréquentes
          </div>
          <h2
            className="font-heading font-bold text-[#0D1B3E]"
            style={{ fontSize: 'clamp(1.6rem,3.5vw,2.5rem)', lineHeight: 1.2 }}
          >
            Tout ce que vous devez savoir
          </h2>
        </div>

        <div className="space-y-3">
          {faqs?.map((faq) => {
            const isOpen = openId === faq?.id;
            return (
              <div
                key={faq?.id}
                className="rounded-2xl overflow-hidden transition-all duration-300"
                style={{
                  border: `1.5px solid ${isOpen ? 'rgba(24,119,242,0.25)' : 'rgba(13,27,62,0.08)'}`,
                  background: isOpen ? 'rgba(24,119,242,0.02)' : 'white',
                }}
              >
                <button
                  className="w-full flex items-center justify-between p-5 text-left"
                  onClick={() => setOpenId(isOpen ? null : faq?.id)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${faq?.id}`}
                >
                  <span
                    className="font-heading font-semibold text-[#0D1B3E] pr-4"
                    style={{ fontSize: 15 }}
                  >
                    {faq?.q}
                  </span>
                  <div
                    className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300"
                    style={{
                      background: isOpen ? '#1877F2' : 'rgba(13,27,62,0.06)',
                      transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                    }}
                  >
                    <Icon
                      name="PlusIcon"
                      size={14}
                      className={isOpen ? 'text-white' : 'text-[#6B7280]'}
                    />
                  </div>
                </button>
                {isOpen && (
                  <div
                    id={`faq-answer-${faq?.id}`}
                    className="px-5 pb-5 text-sm text-[#6B7280] leading-relaxed"
                    style={{ borderTop: '1px solid rgba(13,27,62,0.05)' }}
                  >
                    <p className="pt-4">{faq?.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Contact strip */}
        <div
          className="mt-8 p-5 rounded-2xl flex flex-col sm:flex-row items-center justify-between gap-4"
          style={{ background: 'rgba(13,27,62,0.03)', border: '1px solid rgba(13,27,62,0.08)' }}
        >
          <div>
            <div className="font-semibold text-[#0D1B3E] text-sm mb-0.5">
              Vous avez d'autres questions ?
            </div>
            <div className="text-[#6B7280] text-xs">
              Notre équipe est disponible 7j/7 via WhatsApp.
            </div>
          </div>
          <a
            href="https://wa.me/2250575956671"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold text-white whitespace-nowrap"
            style={{ background: '#25D366', textDecoration: 'none', flexShrink: 0 }}
          >
            💬 WhatsApp Support
          </a>
        </div>
      </div>
    </section>
  );
}